import { Helmet } from 'react-helmet-async'
import { constants } from '../../../utils/constants'
import { Login } from './Login'

export default function LoginPage() {
  return (
    <>
      <Helmet>
        <title> { constants.appName} | Iniciar Sesión</title>
      </Helmet>
      <Login />
    </>
  )
}
